<template>
  <div v-loading="loading">
    <div style="max-height: 300px; overflow: auto;">
        <div class="font12px">工单：</div>
        <div v-for="item in selectList" :key="item.id" class="pl20">
        {{ item.order_name }}(ID:{{ item.order_id }})  (创建人： {{item.create_name}})
        </div>
       
    </div>
     <el-form ref="formRef" :model="formData" class="mt20" @submit.native.prevent>
        <el-form-item label="工单标签：" prop="tag_ids" :rules="[{  required: true, message: '请选择标签', trigger: 'blur' }]">
            <el-select v-model="formData.tag_ids" multiple placeholder="请选择标签" style="width: 400px">
                <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
        </el-form-item>
    </el-form>
    <div class="tac">
        <el-button :disabled="submitLoading"  @click="$emit('close')">取消</el-button>
        <el-button type="primary" :disabled="submitLoading" @click="handleSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
import API from "@/api/workOrder/material.js"
export default {
    props: {
        cbs: Object,
        selectList: { type: Array, default: () => [] },
        type: String,
        // 2026-09-14 排单管理复用：传入则替代默认的 search_config / ${type}/update_work_order_label
        fetchOptions: Function,   // (params) => Promise<{ data: { work_order_label: [{id,name}] } }>
        submit: Function,         // ({ order_id: [], config_id: [] }) => Promise
    },
    data() {
        let tag_ids = [];
        if (this.selectList.length === 1) {
            tag_ids = this.selectList[0].work_order_label.map(v=>v.id)
        }
        return {
            formData: {
                tag_ids
            },
            tagList: [],
            loading: false,
            submitLoading: false
        }
    },
    mounted() {
        this.getConfig()
    },
    methods: {
        async getConfig() {
            try {
                this.loading = true
                const { data } = this.fetchOptions
                    ? await this.fetchOptions({ type: this.type })
                    : await API.getSearchWorkOrderOptions({ type: this.type });
                this.tagList = data.work_order_label;
                const ids = data.work_order_label.map(v=>v.id);
                this.formData.tag_ids = this.formData.tag_ids.filter(v=>ids.includes(v));
                this.loading = false
            } catch (error) {
               this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        },
        async handleSubmit() {
            await this.$refs.formRef.validate();
            try {
                this.submitLoading = true
                const params = {
                    type: this.type,
                    order_id: this.selectList.map(item => item.order_id),
                    config_id: this.formData.tag_ids
                }
                if (this.submit) {
                    await this.submit(params)
                } else {
                    await API.updateWorkOrderLabelApi(params)
                }
                this.$message.success('操作成功')
                this.cbs.onSubmit()
            } catch (error) {
                this.$message.error(error.info)
            }finally {
                this.submitLoading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.num-tip {
    font-size: 14px;
    color: #9c9c9c;
    position: absolute;
    top: 11px;
    left: 90px;
}
</style>